import { useState, useContext } from "react";
import React from "react";
import RichTextEditor from "@mantine/rte";
import supabase from "../utils/supabase";
import { SessionContext } from "../SessionContext";
import { toast, ToastContainer } from "react-toastify";

// Example with imgbb.com, usually you would use similar logic to upload to S3 like storages
// Function must return a promise that resolves with uploaded image url
// After promise is resolved blurred image placeholder with be replaced with uploaded
//

interface UploadResult {
  publicUrl: string | null;
  error: Error | null;
}

const handleImageUpload = (file: File): Promise<string> => {
  return new Promise(async (resolve, reject) => {
    try {
      // Upload image to Supabase storage
      //
      //

      //get uid of the user
      const { data: userid, error: userError } = await supabase
        .from("users")
        .select("id")
        .single();
      if (userError) {
        console.error("Error fetching user id:", userError.message);
        return reject(userError);
      }

      //get the user id
      const uid = userid?.id;
      const { data, error } = await supabase.storage
        .from("post_images")
        .upload(`${uid}/${file.name}`, file);

      if (error) {
        if (error.message.includes("already exists")) {
          console.warn("File already exists. Returning existing URL.");
        } else {
          console.error("Image upload failed:", error.message);
          toast.error(`Image upload failed:${error.message}`);
          return reject(error);
        }
      }

      // Generate public URL for the uploaded image
      const { data: urlData } = supabase.storage
        .from("post_images")
        .getPublicUrl(`${uid}/${file.name}`);

      console.log(urlData);

      resolve(urlData.publicUrl);
    } catch (err) {
      console.error("Error during image upload:", (err as Error).message);
      reject(err);
    }
  });
};

interface PostEditorProps {
  value: string;
  setValue: (value: string) => void;
}

export default function PostEditor({ value, setValue }: PostEditorProps) {
  return (
    <>
      <RichTextEditor
        value={value}
        onChange={setValue}
        onImageUpload={handleImageUpload}
      />
      <ToastContainer />
    </>
  );
}
